(function () {
    'use strict';

    angular
        .module('app')
        .directive('selectioncommandreroute', selectioncommand_reroute);

    selectioncommand_reroute.$inject = ['$window'];

    function selectioncommand_reroute($window) {
        // Usage:
        //     <toolbar></toolbar>
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                rerouteDialogShown: '=?'
            },
            controller: 'reroute',
            templateUrl: 'app/selectioncommand/selectioncommand_reroute.html'
        };
        return directive;

        function link(scope, element, attrs) {

            

        }
    }
})();